module.exports = __webpack_public_path__ + "static/media/devsecops_1.9dc985b1.png";